import React from 'react'
import LearnMenu, { helpCenterLink, learnPages } from './LearnMenu'
import {
  productFeatures,
  productFooterLinks,
  ProductMenu,
  productPages,
} from './ProductMenu'

export type MenuLink = {
  text: string | JSX.Element
  href: string
}
export type SubMenu = {
  text: string
  href?: string
  menuItems: MenuItem[]
  render: () => JSX.Element
}
export type MenuItem = MenuLink | SubMenu
export type MenuItemWithLink = MenuItem & { href: string }

export function isSubMenu(item: MenuItem): item is SubMenu {
  return 'menuItems' in item
}

export function hasLink(item: MenuItem): item is MenuItemWithLink {
  return 'href' in item
}

export function getMenuItemKey(item: MenuItem) {
  return isSubMenu(item) ? item.text : item.href
}

const productMenuItems: MenuItem[] = [
  ...productPages.map(page => ({
    text: page.title,
    href: page.href,
  })),
  {
    text: 'Features',
    href: '/product/',
    menuItems: productFeatures.map(feature => ({
      text: feature.title,
      href: feature.href,
    })),
  },
  ...productFooterLinks.map(link => ({
    text: link.title,
    href: link.href,
  })),
]

const learnMenuItems: MenuLink[] = [
  ...learnPages.map(page => ({
    text: page.title,
    href: page.href,
  })),
  helpCenterLink,
]

export const menuItems: MenuItem[] = [
  {
    text: 'Product',
    menuItems: productMenuItems,
    render: () => <ProductMenu />,
  },
  { text: 'Changelog', href: '/changelog/' },
  { text: 'Pricing', href: '/pricing/' },
  { text: 'Customers', href: '/customers/' },
  {
    text: 'Learn',
    menuItems: learnMenuItems,
    render: () => <LearnMenu />,
  },
  { text: 'About us', href: '/about-us/' },
  { text: 'Careers', href: '/careers/' },
]

export const loginItem: MenuItem = {
  text: 'Log in',
  href: 'https://app.swarmia.com',
}
